export default "__VITE_ASSET__CRiEtmIT__"